import styles from "./NotFoundScreen.module.scss";

import { Trans, useTranslation } from "react-i18next";

import { PageContainer } from "../../components/PageContainer";
import { SUPPORT_EMAIL } from "../../consts/supportEmail";

export const NotFoundScreen = () => {
  const { t } = useTranslation();

  return (
    <PageContainer variant="constrained">
      <div className={styles.container}>
        <span className={styles.title}>{t("common.notFound.title")}</span>
        <span className={styles.description}>
          <Trans
            i18nKey="common.notFound.description"
            values={{ email: SUPPORT_EMAIL }}
            components={{
              first: <span className={styles.description} />,
              supportEmail: <a href={`mailto:${SUPPORT_EMAIL}`} />,
              second: <span className={styles.description} />,
            }}
          />
        </span>
      </div>
    </PageContainer>
  );
};
